'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MainNavigation = /*#__PURE__*/function (_React$Component) {
  _inherits(MainNavigation, _React$Component);

  function MainNavigation(props) {
    _classCallCheck(this, MainNavigation);

    return _possibleConstructorReturn(this, (MainNavigation.__proto__ || Object.getPrototypeOf(MainNavigation)).call(this, props));
  }

  _createClass(MainNavigation, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          t = _this$props.t,
          activeLanguage = _this$props.activeLanguage;
      return /*#__PURE__*/_react.default.createElement("nav", {
        className: 'main-navigation'
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: 'main-navigation-list'
      }, /*#__PURE__*/_react.default.createElement("li", {
        className: 'main-navigation-item main-navigation-item--title'
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: 'cross',
        onClick: this.props.closeNavigation
      }), t('Hof-Suche')), ['menu-about', 'menu-disclaimer', 'menu-impressum'].map(function (item, key) {
        var link = t("".concat(item, " link ").concat(_this.props.theme));
        return /*#__PURE__*/_react.default.createElement("li", {
          key: key,
          className: 'main-navigation-item'
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: link,
          onClick: function onClick(e) {
            return _this.navigate(e, link);
          }
        }, t("".concat(item, " ").concat(_this.props.theme))));
      })), this.props.languages.length > 1 && /*#__PURE__*/_react.default.createElement("ul", {
        className: 'main-navigation-language-menu'
      }, this.props.languages.map(function (language, key) {
        var className = "main-navigation-language-menu-item ".concat(language === activeLanguage ? 'active' : '');
        return /*#__PURE__*/_react.default.createElement("li", {
          key: key,
          className: className
        }, /*#__PURE__*/_react.default.createElement("a", {
          onClick: function onClick(e) {
            return _this.props.changeLanguage(e, language);
          }
        }, language.toUpperCase()));
      })), /*#__PURE__*/_react.default.createElement("ul", {
        className: 'main-navigation-bottom'
      }, /*#__PURE__*/_react.default.createElement("li", {
        className: 'logo logo-ml-middle'
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: "/static/assets/images/logos/logo-".concat(this.props.activeLanguage, ".png")
      })), /*#__PURE__*/_react.default.createElement("li", {
        className: 'logo-ml-middle'
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "logo-project--".concat(this.props.theme, " ") + "logo-project--".concat(this.props.theme, "-").concat(this.props.activeLanguage)
      })), /*#__PURE__*/_react.default.createElement("li", {
        className: "logo-ml-middle schweiz-naturlich schweiz-naturlich-".concat(this.props.activeLanguage)
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: "/static/assets/images/logos/Logo_schw_nat_".concat(this.props.activeLanguage, ".svg")
      }))));
    }
    /**
     *
     * @param e
     * @param path
     */

  }, {
    key: "navigate",
    value: function navigate(e, path) {
      if (!path.startsWith('/')) return;

      if (path === window.location.pathname) {
        this.props.closeNavigation();
      }

      e.preventDefault();
      this.props.history.push(path);
    }
  }]);

  return MainNavigation;
}(_react.default.Component);

MainNavigation.propTypes = {
  t: _propTypes.default.func,
  history: _propTypes.default.shape({
    push: _propTypes.default.func
  }).isRequired,
  navigationItems: _propTypes.default.arrayOf({}),
  activeLanguage: _propTypes.default.string,
  currentLocation: _propTypes.default.string,
  changeLanguage: _propTypes.default.func.isRequired,
  closeNavigation: _propTypes.default.func.isRequired,
  theme: _propTypes.default.string,
  languages: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = MainNavigation;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/main-navigation/index.js
// module id = 884
// module chunks = 0